<template>
  <v-select
    v-model="internalValue"
    clearable
    deselectFromDropdown
    :multiple="multiple"
    :searchable="false"
    label="name"
    :options="pickTypes"
    :placeholder="$t('orders.pickType')"
    :class="['select-chip select-status', customClass]"
  >
    <template slot="no-options"> {{ $t("noRecord") }} </template>

    <template slot="option" slot-scope="option">
      <div :class="`option-chip status-${option.id}`">
        <PickType :item="option" />
      </div>
    </template>
    <template slot="selected-option" slot-scope="option">
      <div :class="`option-chip status-${option.id} selected`">
        <PickType :item="option" />
      </div>
    </template>
    <template #open-indicator="{}">
      <i class="md-icon md-icon-font md-icon-image md-theme-default">
        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 10l5 5 5-5z"></path>
          <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
      </i>
    </template>
  </v-select>
</template>

<script>
import { normalizeStatusName } from "../../mixins/formats";
import PickType from "./PickType.vue";

export default {
  components: {
    PickType,
  },
  props: {
    value: {
      type: [String, Array, Object, Number, null],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localValue: null, // Fallback value
      pickTypes: [
        { id: "na", name: "N/A" },
        { id: "SQP", name: this.$t("orders.pickTypes.SQP") },
        { id: "CAB", name: this.$t("orders.pickTypes.CAB") },
        { id: "CHECK", name: this.$t("orders.pickTypes.CHECK") },
      ],
    };
  },
  computed: {
    internalValue: {
      get() {
        let parsedValue = [];
        if (!this.value) {
          return this.localValue;
        }
        if (Array.isArray(this.value)) {
          parsedValue = [...this.value];
        } else if (typeof this.value === "string") {
          parsedValue = this.value.split(",");
        } else {
          parsedValue = [this.value];
        }
        const res = parsedValue?.map((val) => this.pickTypes.find((pickType) => pickType.name === val)) ?? null;

        return res;
      },
      set(newValue) {
        if (!newValue) {
          this.localValue = newValue;
          this.$emit("input", null);
          return;
        }
        this.localValue = newValue;
        if (this.multiple === true) {
          if (newValue.length === 0) {
            this.$emit("input", null);
            return;
          } else {
            this.$emit(
              "input",
              newValue?.map((item) => item.id)
            );
          }
        } else {
          this.$emit("input", newValue.id);
        }
      },
    },
  },
  methods: {
    clearAll() {
      this.internalValue = [];
    },
    getI18N(prefix, statusName) {
      return this.$t(`${prefix}.${normalizeStatusName(statusName)}`);
    },
  },
};
</script>

<style lang="scss"></style>
